import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"; // Removed Pagination import
import "swiper/css";

const RegistrationSection = () => {
  return (
    <section
      id="registration"
      className="merchandise-section merchandise-1 position-relative mb-50 mb-lg-100 mb-xxl-120 py-50 py-lg-100 py-xxl-120"
    >
      <div className="container" id="ticket">
        <div className="row gy-4 gy-lg-0 align-items-lg-end justify-content-lg-between mb-40 mb-lg-70">
          <div className="col-lg-4">
            <div className="section-title">
              <span className="fs-3 straight-line-wrapper fw-semibold position-relative">
                Lorem ipsum
              </span>
              <h2 className="title display-3 fw-extra-bold d-flex flex-column">
                <span className="mb-n2 text-opacity">Get Your</span>
                <span className="sub-title fw-extra-bold text-primary">
                  Registration
                </span>
              </h2>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="highlights-text">
              <p className="custom-jakarta custom-font-style-2 text-lg-end mb-2">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
          </div>
        </div>
        <div className="merchandise-contents" style={{ position: "relative" }}>
          <div style={{ position: "absolute", top: "10px", right: "10px" }}>
            <img
              src="assets/images/ellipse-4.png"
              style={{ maxWidth: "100%" }}
              alt="img"
            />
          </div>
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]} // Removed Pagination module
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 },
              768: { slidesPerView: 2, spaceBetween: 15 },
              1024: { slidesPerView: 3, spaceBetween: 20 },
            }}
          >
            {[
              {
                imgSrc: "assets/images/registration/Volunteer.png",
                title: "Volunteer",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSePmHdusFo3-doXpJRmMxpmT9aqVweuzQhqn_OGJGcTdV-mLQ/viewform?usp=dialog",
              },
              {
                imgSrc: "assets/images/registration/Exhibitor.png",
                title: "Exhibitor",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSePmHdusFo3-doXpJRmMxpmT9aqVweuzQhqn_OGJGcTdV-mLQ/viewform?usp=dialog",
              },
              {
                imgSrc: "assets/images/Ticket.png",
                title: "Author",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSehWMPA1WSMIC1u54WHSlPRifEf1aP2PF_UBQahAI-SnbqLBw/viewform?usp=dialog",
              },
              {
                imgSrc: "assets/images/registration/Exhibitor.png",
                title: "Exhibitor",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSePmHdusFo3-doXpJRmMxpmT9aqVweuzQhqn_OGJGcTdV-mLQ/viewform?usp=dialog",
              },
              {
                imgSrc: "assets/images/Ticket.png",
                title: "Author",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSehWMPA1WSMIC1u54WHSlPRifEf1aP2PF_UBQahAI-SnbqLBw/viewform?usp=dialog",
              },
              {
                imgSrc: "assets/images/registration/Exhibitor.png",
                title: "Exhibitor",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSePmHdusFo3-doXpJRmMxpmT9aqVweuzQhqn_OGJGcTdV-mLQ/viewform?usp=dialog",
              },
              {
                imgSrc: "assets/images/Ticket.png",
                title: "Author",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSehWMPA1WSMIC1u54WHSlPRifEf1aP2PF_UBQahAI-SnbqLBw/viewform?usp=dialog",
              },
            ].map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="merchandise-wrapper"
                  style={{ textAlign: "center", margin: "10px" }}
                >
                  <div
                    className="merchandise-image"
                    style={{ marginBottom: "20px" }}
                  >
                    <img
                      src={item.imgSrc}
                      alt={item.title}
                      style={{ maxWidth: "100%" }}
                    />
                  </div>
                  <h5 style={{ fontSize: "1rem", fontWeight: "700" }}>
                    {item.title}
                  </h5>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "10px",
                      padding: "10px 20px",
                      border: "1px solid #007bff",
                      color: "#007bff",
                      textDecoration: "none",
                      borderRadius: "5px",
                    }}
                  >
                    Register
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default RegistrationSection;
